import React, { useEffect, useState } from "react";
import { Tabs, Tab, Spinner } from "react-bootstrap";
import "moment-timezone";
import moment from "moment";
import { PaymentService } from "../../../service/PaymentService";
import { Utility } from "../../../Helpers/utils";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
import { ConvertDateFormat } from "../../../components/ConvertDateFormat";
import ShowIssuesModal from "./components/modals/ShowIssuesModal";
import PaymentMadeModal from "./components/modals/PaymentMadeModal";
import AllPaymentsList from "./components/AllPaymentsList";
// import { withRouter } from "react-router";
// const { SearchBar } = Search;

const InstantPayPayment = () => {
  const [barTenderPayment, setBarTenderPayment] = useState(null);
  const [tipIncomeReport, setTipIncomeReport] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [salesReport, setSalesReport] = useState(null);
  // const [madePayment, setMadePayment] = useState(false);
  const [madePaymentModal, setMadePaymentModal] = useState(false);
  const [successfulPayments, setSuccessfulPayments] = useState(null);
  const [failedPayments, setFailedPayments] = useState(null);
  const [scheduledPayment, setScheduledPayment] = useState(null);
  const [otherPayments, setOtherPayments] = useState(null);
  const [togoPayments, setTogoPayments] = useState(null);
  const [tipsharePayments, setTipsharePayments] = useState(null);
  const [atoPaymentDetails, setAtoPaymentDetails] = useState(null);
  const [doorDashPaymentDetails, setDoorDashPaymentDetails] = useState(null);
  const [cateringPayments, setCateringPayments] = useState(null);
  const [cateringResponses, setCateringResponses] = useState(null);
  const [coachServerEmployees, setCoachServerEmployees] = useState(null);
  const [extractedServers, setExtractedServers] = useState(null);
  const [storeDetails, setStoreDetails] = useState(null);
  const [showIssuesModal, setShowIssuesModal] = useState(false);

  const user = Utility.getUser();
  let history = useHistory();

  // Check if current store is Casi Cielo (location_id 500 and above)
  const isCasiCielo =
    storeDetails &&
    (storeDetails.name?.toLowerCase().includes("casi cielo") ||
      Number(storeDetails.location_id) >= 500);

  useEffect(() => {
    var btn = document.getElementsByTagName("button")[5];
    if (btn) {
      if (btn.disabled) {
        btn.disabled = false;
      }
    }

    // Load store details to check if it's Casi Cielo
    if (JSON.parse(localStorage.getItem("storeDetails"))) {
      setStoreDetails(JSON.parse(localStorage.getItem("storeDetails")));
    }

    if (JSON.parse(localStorage.getItem("tipIncomeReport"))) {
      console.log(JSON.parse(localStorage.getItem("tipIncomeReport")));
      setTipIncomeReport(JSON.parse(localStorage.getItem("tipIncomeReport")));
    }

    if (JSON.parse(localStorage.getItem("otherEmpdetails"))) {
      console.log(JSON.parse(localStorage.getItem("otherEmpdetails")));
      setOtherPayments(JSON.parse(localStorage.getItem("otherEmpdetails")));
    }

    if (JSON.parse(localStorage.getItem("cateringPayments"))) {
      console.log(JSON.parse(localStorage.getItem("cateringPayments")));
      setCateringPayments(JSON.parse(localStorage.getItem("cateringPayments")));
    }

    if (JSON.parse(localStorage.getItem("atoPaymentDetails"))) {
      console.log(JSON.parse(localStorage.getItem("atoPaymentDetails")));
      setAtoPaymentDetails(JSON.parse(localStorage.getItem("atoPaymentDetails")));
    }

    if (JSON.parse(localStorage.getItem("doorDashPaymentDetails"))) {
      console.log(JSON.parse(localStorage.getItem("doorDashPaymentDetails")));
      setDoorDashPaymentDetails(JSON.parse(localStorage.getItem("doorDashPaymentDetails")));
    }

    if (JSON.parse(localStorage.getItem("togoCalculatedPayments"))) {
      const savedTogo = JSON.parse(localStorage.getItem("togoCalculatedPayments"));
      console.log(savedTogo);
      // Accept the wrapped shape written by an earlier build ({ togoPayments, tipsharePayments })
      setTogoPayments(savedTogo.togoPayments || savedTogo);
    } else if (JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"))) {
      const combinedData = JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"));
      console.log(combinedData);
      if (combinedData.togoPayments) {
        setTogoPayments(combinedData.togoPayments);
      }
      // Load tipshare payments for Casi Cielo
      if (combinedData.tipsharePayments) {
        console.log("Loading tipshare payments:", combinedData.tipsharePayments);
        setTipsharePayments(combinedData.tipsharePayments);
      }
    }

    // Removed individual TOGO validation alert - now handled in unified validation

    // Removed individual tipshare validation alert - now handled in unified validation

    if (JSON.parse(localStorage.getItem("atoDoorDashTips"))) {
      if (
        JSON.parse(localStorage.getItem("atoDoorDashTips")).atoTips &&
        !JSON.parse(localStorage.getItem("atoPaymentDetails"))
      ) {
        // Removed individual alert - now handled in unified validation
      }
    }

    if (JSON.parse(localStorage.getItem("laborInfoDetails"))) {
      console.log(JSON.parse(localStorage.getItem("laborInfoDetails")).cateringResponses);
      setCateringResponses(JSON.parse(localStorage.getItem("laborInfoDetails")).cateringResponses);

      setExtractedServers(JSON.parse(localStorage.getItem("tipIncomeReport")).server);

      setCoachServerEmployees(JSON.parse(localStorage.getItem("tipIncomeReport")).diff);
    }

    if (JSON.parse(localStorage.getItem("barTenderPayment"))) {
      console.log(JSON.parse(localStorage.getItem("barTenderPayment")));
      setBarTenderPayment(JSON.parse(localStorage.getItem("barTenderPayment")));
    }

    if (JSON.parse(localStorage.getItem("salesReport"))) {
      const salesReport = JSON.parse(localStorage.getItem("salesReport"));
      PaymentService.getScheduledPayment(salesReport.owner)
        .then((response) => {
          console.log(response.data.data);
          setScheduledPayment(response.data.data);
        })
        .catch((error) => {
          console.log(error.response.data);
        });

      setSalesReport(JSON.parse(localStorage.getItem("salesReport")));
    }

    if (JSON.parse(localStorage.getItem("expenses"))) {
      console.log(JSON.parse(localStorage.getItem("expenses")));
      const exp_tot = JSON.parse(localStorage.getItem("expenses"));
      console.log(exp_tot);
    }
  }, [isCasiCielo]);

  const roundNumberUp = (num) => {
    return (Math.round(num * 100) / 100).toFixed(2);
  };

  const handleModalClose = () => {
    setMadePaymentModal(false);
    history.push("/financials/view-store-report");
  };

  // Function to check payment readiness and return error message if any
  const checkPaymentReadiness = () => {
    const errors = [];

    // Debug info for Casi Cielo tipshare issue
    if (isCasiCielo) {
      console.log("=== CASI CIELO DEBUG INFO ===");
      console.log("isCasiCielo:", isCasiCielo);
      console.log("storeDetails:", storeDetails);
      console.log("togoPayments localStorage:", localStorage.getItem("togoPayments"));
      console.log(
        "togoAndTipshareCalculatedPayments localStorage:",
        localStorage.getItem("togoAndTipshareCalculatedPayments")
      );
      console.log(
        "togoCalculatedPayments localStorage:",
        localStorage.getItem("togoCalculatedPayments")
      );
    }

    // Debug info for Online Tips/DoorDash validation
    const atoDoorDashData = JSON.parse(localStorage.getItem("atoDoorDashTips"));
    if (atoDoorDashData) {
      console.log("=== ONLINE TIPS/DOORDASH DEBUG INFO ===");
      console.log("atoDoorDashTips:", atoDoorDashData);
      console.log("atoPaymentDetails:", localStorage.getItem("atoPaymentDetails"));
      console.log("doorDashPaymentDetails:", localStorage.getItem("doorDashPaymentDetails"));
      console.log(
        "ATO Tips Amount:",
        atoDoorDashData.atoTips,
        "Type:",
        typeof atoDoorDashData.atoTips
      );
      console.log(
        "DoorDash Tips Amount:",
        atoDoorDashData.doorDashTips,
        "Type:",
        typeof atoDoorDashData.doorDashTips
      );
    }

    // Check for required bartender payments
    if (!barTenderPayment) {
      errors.push({
        type: "critical",
        title: "Bartender Payments Missing",
        description: "Bartender payments are missing. Please ensure bartender data is processed.",
        action: "Go back to the Bartender stage and process payments",
      });
    }

    // Check for server payments in tip income report only if it exists and has server data
    if (tipIncomeReport && tipIncomeReport.server && tipIncomeReport.server.length > 0) {
      const invalidServers = tipIncomeReport.server.filter((s) => !s.tip_owed || s.tip_owed <= 0);
      if (invalidServers.length > 0) {
        errors.push({
          type: "warning",
          title: "Invalid Server Tip Amounts",
          description: `${invalidServers.length} server(s) have invalid tip amounts.`,
          action: "Review and correct the tip income report",
        });
      }
    }

    // Check for TOGO payments if they exist in localStorage but aren't calculated
    if (JSON.parse(localStorage.getItem("togoPayments"))) {
      const hasTogoTips = JSON.parse(localStorage.getItem("togoPayments")).togoTotalTips;
      const hasCalculatedTogo =
        JSON.parse(localStorage.getItem("togoCalculatedPayments")) ||
        JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"));

      if (hasTogoTips && !hasCalculatedTogo) {
        errors.push({
          type: "critical",
          title: "TOGO Payments Not Computed",
          description: "TOGO payments need to be calculated and submitted.",
          action: "Go to the TOGO stage and complete payment calculations",
        });
      }
    }

    // Check for tipshare payments for Casi Cielo ONLY
    if (isCasiCielo) {
      const combinedData = JSON.parse(localStorage.getItem("togoAndTipshareCalculatedPayments"));
      const togoRawData = JSON.parse(localStorage.getItem("togoPayments"));

      // Tipshare must be submitted whenever there is tipshare to pay, even if ToGo is $0
      const hasTipshareToPay =
        (Array.isArray(togoRawData?.tipshare_tips) && togoRawData.tipshare_tips.length > 0) ||
        parseFloat(togoRawData?.tipshare_total_tips || 0) > 0;
      const hasTipsharePayments = combinedData?.tipsharePayments;

      if (hasTipshareToPay && !hasTipsharePayments) {
        errors.push({
          type: "critical",
          title: "Tip Share Not Submitted (Casi Cielo)",
          description: "Hostess tip share has not been submitted, so it would not be paid.",
          action: "Go back to the TOGO stage and click Submit under TIPSHARE TIPS",
        });
      }
    }

    // Check for ATO/DoorDash payments if they exist but aren't processed
    if (JSON.parse(localStorage.getItem("atoDoorDashTips"))) {
      const atoDoorDashData = JSON.parse(localStorage.getItem("atoDoorDashTips"));
      const hasAtoTips = atoDoorDashData.atoTips && parseFloat(atoDoorDashData.atoTips) > 0;
      const hasDoorDashTips =
        atoDoorDashData.doorDashTips && parseFloat(atoDoorDashData.doorDashTips) > 0;
      const hasAtoPayments = JSON.parse(localStorage.getItem("atoPaymentDetails"));
      const hasDoorDashPayments = JSON.parse(localStorage.getItem("doorDashPaymentDetails"));

      // Check if ATO tips exist but payments aren't processed
      if (hasAtoTips && !hasAtoPayments) {
        errors.push({
          type: "critical",
          title: "Online Tips Not Computed",
          description: `Online delivery tips ($${parseFloat(atoDoorDashData.atoTips).toFixed(
            2
          )}) need to be calculated and submitted.`,
          action: "Go to the Online Tips/DoorDash stage and process ATO payments",
        });
      }

      // Check if DoorDash tips exist but payments aren't processed
      if (hasDoorDashTips && !hasDoorDashPayments) {
        errors.push({
          type: "critical",
          title: "DoorDash Tips Not Computed",
          description: `DoorDash delivery tips ($${parseFloat(atoDoorDashData.doorDashTips).toFixed(
            2
          )}) need to be calculated and submitted.`,
          action: "Go to the Online Tips/DoorDash stage and process DoorDash payments",
        });
      }

      // If both exist, ensure both are processed together
      if ((hasAtoTips || hasDoorDashTips) && hasAtoPayments && !hasDoorDashPayments) {
        errors.push({
          type: "warning",
          title: "Incomplete Online Delivery Processing",
          description:
            "ATO payments processed but DoorDash payments are missing. Both should be completed together.",
          action: "Complete the DoorDash payment processing",
        });
      }
    }

    return errors;
  };

  // Function to show detailed error messages in a unified popup
  const showPaymentErrors = () => {
    const errors = checkPaymentReadiness();
    if (errors.length > 0) {
      const criticalErrors = errors.filter((e) => e.type === "critical");
      const warningErrors = errors.filter((e) => e.type === "warning");

      let htmlContent = `
        <div style="text-align: left; max-height: 400px; overflow-y: auto;">
          <p style="margin-bottom: 20px; color: #666;">
            ${
              criticalErrors.length > 0
                ? "Please resolve the following issues before processing payments:"
                : "Please review the following before processing payments (these won't block payment):"
            }
          </p>
      `;

      if (criticalErrors.length > 0) {
        htmlContent += `
          <div style="margin-bottom: 20px;">
            <h4 style="color: #dc3545; margin-bottom: 10px; font-size: 16px;">
              <i class="mdi mdi-alert-circle"></i> Critical Issues
            </h4>
        `;
        criticalErrors.forEach((error, index) => {
          htmlContent += `
            <div style="background: #fff5f5; border: 1px solid #feb2b2; border-radius: 4px; padding: 12px; margin-bottom: 10px;">
              <div style="font-weight: bold; color: #dc3545; margin-bottom: 5px;">
                ${error.title}
              </div>
              <div style="color: #666; margin-bottom: 5px; font-size: 14px;">
                ${error.description}
              </div>
              <div style="color: #059862; font-size: 13px; font-style: italic;">
                <i class="mdi mdi-lightbulb-outline"></i> ${error.action}
              </div>
            </div>
          `;
        });
        htmlContent += `</div>`;
      }

      if (warningErrors.length > 0) {
        htmlContent += `
          <div>
            <h4 style="color: #ff8c00; margin-bottom: 10px; font-size: 16px;">
              <i class="mdi mdi-alert"></i> Warnings
            </h4>
        `;
        warningErrors.forEach((error, index) => {
          htmlContent += `
            <div style="background: #fffbf0; border: 1px solid #fed7aa; border-radius: 4px; padding: 12px; margin-bottom: 10px;">
              <div style="font-weight: bold; color: #ff8c00; margin-bottom: 5px;">
                ${error.title}
              </div>
              <div style="color: #666; margin-bottom: 5px; font-size: 14px;">
                ${error.description}
              </div>
              <div style="color: #059862; font-size: 13px; font-style: italic;">
                <i class="mdi mdi-lightbulb-outline"></i> ${error.action}
              </div>
            </div>
          `;
        });
        htmlContent += `</div>`;
      }

      htmlContent += `</div>`;

      Swal.fire({
        title: "Payment Requirements",
        html: htmlContent,
        icon: criticalErrors.length > 0 ? "error" : "warning",
        confirmButtonText: "Got it",
        confirmButtonColor: "#000000",
        allowEscapeKey: true,
        allowOutsideClick: true,
        width: "600px",
        customClass: {
          popup: "payment-requirements-popup",
        },
      });
    }
  };

  // Only critical issues block payment; warnings (e.g. servers with $0 tips) are informational
  const hasBlockingIssues = () => checkPaymentReadiness().some((e) => e.type === "critical");
  const hasWarnings = () => checkPaymentReadiness().some((e) => e.type === "warning");

  const instantPayPayment = () => {
    // Use unified validation check before proceeding
    if (hasBlockingIssues()) {
      showPaymentErrors();
      return;
    }

    Swal.fire({
      title: "Are you sure?",
      text: "You are about to process all payments. Please note that no further changes can be made to this report. Click yes to proceed!",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#000000",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSubmitting(true);
        if (JSON.parse(localStorage.getItem("newCompletedSalesReport"))) {
          localStorage.removeItem("newCompletedSalesReport");
        }
        Swal.fire({
          title: "In progress",
          text: "Please wait...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          onOpen: () => {
            Swal.showLoading();
          },
        });

        let today = moment.tz(new Date(), "America/New_York");
        let barPaymentData = [];
        let serverPaymentData = [];
        let coachServerPaymentData = [];
        let scheduledPaymentData = [];
        let cateringPaymentData = [];
        let togoPaymentData = [];
        let tipsharePaymentData = [];
        let atoPaymentData = [];
        let doorDashPaymentData = [];
        let barPaymentTotal = 0;
        let serverPaymentTotal = 0;
        let coachServerPaymentTotal = 0;
        let scheduledPaymentTotal = 0;
        let cateringPaymentTotal = 0;
        let togoPaymentTotal = 0;
        let tipsharePaymentTotal = 0;
        let atoPaymentTotal = 0;
        let doorDashPaymentTotal = 0;

        // bartenders
        if (barTenderPayment) {
          barTenderPayment.tipSummary.map((bar, index) => {
            let splitName = bar.name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            barPaymentTotal += parseFloat(roundNumberUp(bar.instant_pay_total));
            barPaymentData.push({
              payrollEmployeeId: `${bar.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "bartender",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(bar.instant_pay_total)),
              tip: parseFloat(roundNumberUp(bar.tip_owed)),
              tipshare: parseFloat(roundNumberUp(bar.total_tipshare_received)),
              declaredTips: parseFloat(roundNumberUp(bar.declared_tips)),
            });
            return barPaymentData;
          });
        }

        // servers
        if (tipIncomeReport && tipIncomeReport.server) {
          tipIncomeReport.server.map((server, index) => {
            let splitName = server.employee_name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            serverPaymentTotal += parseFloat(roundNumberUp(server.tip_owed));
            serverPaymentData.push({
              payrollEmployeeId: `${server.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "server",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(server.tip_owed)),
            });
            return serverPaymentData;
          });
        }

        // catering
        if (cateringPayments) {
          cateringPayments.map((cat, index) => {
            let splitName = cat.employee_name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            cateringPaymentTotal += parseFloat(roundNumberUp(cat.tip_owed));
            cateringPaymentData.push({
              payrollEmployeeId: `${cat.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "catering",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(cat.tip_owed)),
            });
            return cateringPaymentData;
          });
        }

        // ToGo
        if (togoPayments) {
          togoPayments.togoPaymentDetails.map((togo, index) => {
            let splitName = togo.employee_name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            togoPaymentTotal += parseFloat(roundNumberUp(togo.tipshare_received));
            togoPaymentData.push({
              payrollEmployeeId: `${togo.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "togo",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(togo.tipshare_received)),
              declaredTips: parseFloat(roundNumberUp(togo.declared_tips)),
            });
            return togoPaymentData;
          });
        }

        // Tipshare Tips (Casi Cielo only)
        if (tipsharePayments && isCasiCielo) {
          console.log("Processing tipshare payments for Casi Cielo:", tipsharePayments);
          tipsharePayments.tipsharePaymentDetails.map((tipshare, index) => {
            let splitName = tipshare.employee_name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            tipsharePaymentTotal += parseFloat(roundNumberUp(tipshare.tipshare_received));
            tipsharePaymentData.push({
              payrollEmployeeId: `${tipshare.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "tipshare",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(tipshare.tipshare_received)),
              declaredTips: parseFloat(roundNumberUp(tipshare.declared_tips || 0)),
            });
            return tipsharePaymentData;
          });
        }

        // ATO Payments
        if (atoPaymentDetails) {
          atoPaymentDetails.map((ato, index) => {
            let splitName = ato.name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            atoPaymentTotal += parseFloat(roundNumberUp(ato.tipShareReceived));
            atoPaymentData.push({
              payrollEmployeeId: `${ato.employeeId}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "ato",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(ato.tipShareReceived)),
            });
            return atoPaymentData;
          });
        }

        // Door Dash Payments
        if (doorDashPaymentDetails) {
          doorDashPaymentDetails.map((door, index) => {
            let splitName = door.name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            doorDashPaymentTotal += parseFloat(roundNumberUp(door.tipShareReceived));
            doorDashPaymentData.push({
              payrollEmployeeId: `${door.employeeId}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "doorDash",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(door.tipShareReceived)),
            });
            return doorDashPaymentData;
          });
        }

        // other payments ( TOGO and others)
        if (otherPayments) {
          otherPayments.map((server, index) => {
            let splitName = server.employee_name.split(" ");
            let firstName, lastName;
            if (splitName.length > 2) {
              firstName = splitName[0];
              lastName = splitName[1] + " " + splitName[2];
            } else {
              firstName = splitName[0];
              lastName = splitName[1];
            }
            coachServerPaymentTotal += parseFloat(roundNumberUp(server.tip_owed));
            coachServerPaymentData.push({
              payrollEmployeeId: `${server.employee_number}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "others",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName,
                lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(server.tip_owed)),
            });
            return coachServerPaymentData;
          });
        }

        // scheduled payments
        if (scheduledPayment) {
          scheduledPayment.map((sch, index) => {
            scheduledPaymentTotal += parseFloat(roundNumberUp(sch.amount));
            scheduledPaymentData.push({
              payrollEmployeeId: `${sch.payrollEmployeeId}`,
              externalLocationId: salesReport ? salesReport.owner : "",
              employeeType: "scheduled",
              reportDate: salesReport ? salesReport.report_date : "",
              employeeInfo: {
                firstName: sch.firstName,
                lastName: sch.lastName,
              },
              paymentType: "Tips",
              payDisbursementDateTime: today.format(),
              allocationDate: today.format("yyyy-MM-DD"),
              amount: parseFloat(roundNumberUp(sch.amount)),
            });

            return scheduledPaymentData;
          });
        }

        let payData = {
          paymentDetails: barPaymentData.concat(
            serverPaymentData,
            scheduledPaymentTotal > 0 ? scheduledPaymentData : [],
            coachServerPaymentTotal > 0 ? coachServerPaymentData : [],
            cateringPaymentTotal > 0 ? cateringPaymentData : [],
            togoPaymentTotal > 0 ? togoPaymentData : [],
            tipsharePaymentTotal > 0 ? tipsharePaymentData : [],
            atoPaymentTotal > 0 ? atoPaymentData : [],
            doorDashPaymentTotal > 0 ? doorDashPaymentData : []
          ),
          paid_by_slug: user ? user.slug : null,
          manager_name: salesReport ? salesReport.printed_by : "",
          store_id: salesReport ? salesReport.owner : "",
          store_location: salesReport ? salesReport.location : "",
          report_date: salesReport ? salesReport.report_date : "",
        };

        console.log(payData);
        const totalPaymentSent =
          parseFloat(barPaymentTotal) +
          parseFloat(serverPaymentTotal) +
          (scheduledPaymentTotal > 0 ? parseFloat(scheduledPaymentTotal) : 0) +
          (coachServerPaymentTotal > 0 ? parseFloat(coachServerPaymentTotal) : 0) +
          (cateringPaymentTotal > 0 ? parseFloat(cateringPaymentTotal) : 0) +
          (togoPaymentTotal > 0 ? parseFloat(togoPaymentTotal) : 0) +
          (tipsharePaymentTotal > 0 ? parseFloat(tipsharePaymentTotal) : 0) +
          (atoPaymentTotal > 0 ? parseFloat(atoPaymentTotal) : 0) +
          (doorDashPaymentTotal > 0 ? parseFloat(doorDashPaymentTotal) : 0);

        PaymentService.payTip(payData)
          .then((response) => {
            console.log(response.data.data);

            // setMadePayment(true);
            const instantSuccessRes = response.data.data.content.successes;
            const instantErrorRes = response.data.data.content.errors;

            console.log(instantSuccessRes, instantErrorRes);
            let errorAmount = 0;
            // let totalSuccessAmount = 0;
            let errorPaymentArray = [];
            let successPaymentArray = [];

            if (instantSuccessRes.length > 0) {
              instantSuccessRes.map((val, index) => {
                // totalSuccessAmount += val.amount;
                successPaymentArray.push({
                  _uuid: val._uuid,
                  allocationDate: val.allocatedAt,
                  amount: val.amount,
                  balance: val.balance,
                  firstName: val.raw.firstName,
                  lastName: val.raw.lastName,
                  clientId: val.clientId,
                  locationId: val.locationId,
                  referenceId: val.referenceId,
                  paymentMessage: val.processingResult.message,
                  employeeInfo: {
                    firstName: val.raw.firstName,
                    lastName: val.raw.lastName,
                  },
                  externalLocationId: val.raw.externalLocationId,
                  payDisbursementDateTime: val.processAt,
                  paymentType: "Tips",
                  payrollEmployeeId: val.raw.employeeId,
                  processingResult: {
                    code: val.processingResult.code,
                    message: val.processingResult.message,
                  },
                });
                return successPaymentArray;
              });
            } else {
              console.log("Success is less than 1");
            }
            if (instantErrorRes.length > 0) {
              instantErrorRes.map((val, index) => {
                errorAmount += parseFloat(val.amount);
                errorPaymentArray.push({
                  allocationDate: val.allocatedAt,
                  amount: val.amount,
                  firstName: val.raw.firstName,
                  lastName: val.raw.lastName,
                  employeeInfo: {
                    firstName: val.raw.firstName,
                    lastName: val.raw.lastName,
                  },
                  externalLocationId: val.raw.externalLocationId,
                  payDisbursementDateTime: val.processAt,
                  paymentType: "Tips",
                  payrollEmployeeId: val.raw.employeeId,
                  errorMessage: val.failureReason.message,
                  failureReason: {
                    code: val.failureReason.code,
                    message: val.failureReason.message,
                  },
                });
                return errorPaymentArray;
              });
            } else {
              console.log("Error is less than 1");
            }

            const totalFailedAmount = parseFloat(errorAmount);

            const differencesInTransaction =
              parseFloat(totalPaymentSent) - parseFloat(totalFailedAmount);

            const paymentHistoryData = {
              successful: successPaymentArray,
              failedPending: errorPaymentArray,
              scheduled: scheduledPayment,
              totalPaymentSent,
              totalFailedAmount,
              differencesInTransaction,
              storeId: salesReport ? salesReport.owner : "",
              reportDate: salesReport ? salesReport.report_date : "",
              storeLocation: salesReport ? salesReport.location : "",
              paid_by_slug: user ? user.slug : null,
              // depositData: depositData ? depositData : null,
              cateringResponses: cateringResponses ? cateringResponses : [],
              coachServerEmployees: coachServerEmployees ? coachServerEmployees : [],
              extractedServers: extractedServers ? extractedServers : [],
              cateringPayments: cateringPayments ? cateringPayments : [],
            };

            console.log(paymentHistoryData, "This is payment history");

            Swal.fire({
              title: "Almost done",
              text: "Processing files and sending emails...",
              allowEscapeKey: false,
              allowOutsideClick: false,
              onOpen: () => {
                Swal.showLoading();
              },
            });

            PaymentService.proccessInstantPayResponse(paymentHistoryData)
              .then((response) => {
                console.log(response.data.data, "This is the final report");

                let successRes = response.data.data.success;
                let failedRes = response.data.data.failed;

                setFailedPayments(failedRes);
                setSuccessfulPayments(successRes);

                if (successRes.length > 0 && failedRes.length < 1) {
                  setMadePaymentModal(false);
                  setIsSubmitting(false);
                  Swal.fire({
                    title: "Good Job!",
                    text: "All payments have been scheduled successfully",
                    icon: "success",
                    confirmButtonText: "Ok",
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      console.log("redirection should work");
                      // Clear data from storage
                      localStorage.removeItem("salesReport");
                      localStorage.removeItem("tipDetailsReport");
                      localStorage.removeItem("tipDetailsBartender");
                      localStorage.removeItem("tipIncomeReport");
                      localStorage.removeItem("barTenderPayment");
                      localStorage.removeItem("cateringPayments");
                      localStorage.removeItem("laborInfoDetails");
                      localStorage.removeItem("mergedEmpDetails");
                      localStorage.removeItem("togoPayments");

                      localStorage.removeItem("doorDashPaymentDetails");
                      localStorage.removeItem("togoCalculatedPayments");
                      localStorage.removeItem("togoAndTipshareCalculatedPayments");
                      localStorage.removeItem("otherEmpdetails");
                      localStorage.removeItem("laborBartenders");
                      localStorage.removeItem("atoPaymentDetails");
                      localStorage.removeItem("storeDetails");
                      localStorage.removeItem("atoDoorDashTips");
                      localStorage.removeItem("atoOption");
                      localStorage.removeItem("expenses");

                      // history.push("/form-manager/preview-closing-report");
                      history.push("/financials/view-closing-report", {
                        store_id: response.data.data.finalSalesReport.owner,
                        report_date: ConvertDateFormat(
                          response.data.data.finalSalesReport.report_date
                        ),
                      });
                    }
                  });
                } else {
                  Swal.close();
                  setMadePaymentModal(true);
                  setIsSubmitting(false);
                  localStorage.removeItem("salesReport");
                  localStorage.removeItem("tipDetailsReport");
                  localStorage.removeItem("tipDetailsBartender");
                  localStorage.removeItem("tipIncomeReport");
                  localStorage.removeItem("barTenderPayment");
                  localStorage.removeItem("cateringPayments");
                  localStorage.removeItem("laborInfoDetails");
                  localStorage.removeItem("mergedEmpDetails");
                  localStorage.removeItem("togoPayments");

                  localStorage.removeItem("doorDashPaymentDetails");
                  localStorage.removeItem("togoCalculatedPayments");
                  localStorage.removeItem("togoAndTipshareCalculatedPayments");
                  localStorage.removeItem("otherEmpdetails");
                  localStorage.removeItem("laborBartenders");
                  localStorage.removeItem("atoPaymentDetails");
                  localStorage.removeItem("storeDetails");
                  localStorage.removeItem("atoDoorDashTips");
                  localStorage.removeItem("atoOption");
                  localStorage.removeItem("expenses");
                }
              })
              .catch((error) => {
                console.log(error);
                console.log("Processing payment responses failed");
              });
          })
          .catch((error) => {
            console.log(error);
            setIsSubmitting(false);
            Swal.fire({
              title: "Error",
              text: "Could not process payment at this time. Please click on the button below to send messages to site administrator",
              icon: "info",
              confirmButtonText: "Ok",
              allowEscapeKey: false,
              allowOutsideClick: false,
            }).then((result) => {
              if (result.isConfirmed) {
                console.log("redirection should work");
                setShowIssuesModal(true);
                Swal.close();
              }
            });
          });
      }
    });
  };

  return (
    <section className="content" id="previewStage">
      <div className="row">
        <div className="col-md-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              {/* <h4 className="card-title">Basic Tab</h4> */}
              <Tabs defaultActiveKey="instantPay" id="uncontrolled-tab-example">
                <Tab eventKey="instantPay" title="All InstantPay Payments">
                  <AllPaymentsList
                    tipIncomeReport={tipIncomeReport}
                    atoPaymentDetails={atoPaymentDetails}
                    doorDashPaymentDetails={doorDashPaymentDetails}
                    otherPayments={otherPayments}
                    barTenderPayment={barTenderPayment}
                    cateringPayments={cateringPayments}
                    togoPayments={togoPayments}
                    tipsharePayments={tipsharePayments}
                    scheduledPayment={scheduledPayment}
                    isCasiCielo={isCasiCielo}
                  />
                </Tab>
              </Tabs>

              <div className="mt-4">
                <button
                  id="processPaymentButton"
                  className="btn btn-primary"
                  disabled={hasBlockingIssues()}
                  onClick={(e) => {
                    if (hasBlockingIssues()) {
                      showPaymentErrors();
                    } else {
                      instantPayPayment();
                    }
                  }}
                >
                  {" "}
                  Process All Payment &nbsp;&nbsp;
                  {isSubmitting ? <Spinner animation="border" size="sm" /> : ""}
                </button>

                {/* Warnings only: payment is allowed, but let the manager review them */}
                {!hasBlockingIssues() && hasWarnings() && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="mdi mdi-alert-outline"></i> There are warnings you may want to
                      review before processing.
                    </small>
                    <br />
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 mt-1"
                      onClick={showPaymentErrors}
                    >
                      <small>Review warnings</small>
                    </button>
                  </div>
                )}

                {/* Show helper text when button is disabled */}
                {hasBlockingIssues() && (
                  <div className="mt-2">
                    <small className="text-muted">
                      <i className="mdi mdi-information-outline"></i> Button disabled - click for
                      details about missing requirements
                    </small>
                    <br />
                    <button
                      type="button"
                      className="btn btn-link btn-sm p-0 mt-1"
                      onClick={showPaymentErrors}
                    >
                      <small>Click here to see what's missing</small>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        {madePaymentModal && (
          <PaymentMadeModal
            handleModalClose={handleModalClose}
            madePaymentModal={madePaymentModal}
            successfulPayments={successfulPayments}
            failedPayments={failedPayments}
            isSubmitting={isSubmitting}
          />
        )}
      </div>

      <div className="row">
        {showIssuesModal && (
          <ShowIssuesModal
            salesReport={salesReport}
            showIssuesModal={showIssuesModal}
            setShowIssuesModal={setShowIssuesModal}
          />
        )}
      </div>
    </section>
  );
};

export default InstantPayPayment;
